// src/components/common/LoadingSpinner.js
import { Box, CircularProgress, Fade, Typography } from "@mui/material";
import { alpha, useTheme } from "@mui/material/styles"; // Importar alpha
import React from "react";
import { useTranslation } from "react-i18next";

const LoadingSpinner = ({
  loading = true,
  size = 60,
  thickness = 4,
  minHeight = "200px",
  message,
  timeout = 500,
  fullPage = false,
}) => {
  const { t } = useTranslation();
  const theme = useTheme(); // Usar tema global

  // No renderizar nada si no está cargando
  if (!loading) return null;

  // Texto de carga (personalizable o por defecto traducido)
  const loadingText = message || t("common.loading");

  return (
    <Fade in={loading} timeout={timeout}>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          minHeight: fullPage ? "100vh" : minHeight,
          width: "100%",
          position: fullPage ? "fixed" : "relative",
          top: fullPage ? 0 : "auto",
          left: fullPage ? 0 : "auto",
          zIndex: fullPage ? theme.zIndex.modal : "auto",
          backgroundColor: fullPage
            ? alpha(theme.palette.background.default, 0.9) // <-- Usar color de fondo del tema con transparencia
            : "transparent",
        }}
        role="status"
        aria-live="polite"
        aria-busy="true"
      >
        <CircularProgress
          sx={{
            color: theme.palette.primary.main,
            mb: 2,
          }}
          size={size}
          thickness={thickness}
        />
        <Typography
          variant="body1"
          sx={{
            color: theme.palette.text.secondary,
            fontSize: { xs: "1rem", sm: "1.2rem" },
            fontWeight: 500,
          }}
        >
          {loadingText}
        </Typography>
      </Box>
    </Fade>
  );
};

export default LoadingSpinner;
